import React, { useState, useContext } from "react";
import { Form, Button, Checkbox, Grid } from "semantic-ui-react";
import { IUserChangePassword } from "../../app/models/user";
import { Form as FinalForm, Field } from "react-final-form";
import TextInput from "../../app/common/form/TextInput";
import { toast } from "react-toastify";
import { RootStoreContext } from "../../app/stores/rootStore";
import {
  combineValidators,
  composeValidators,
  isRequired,
  hasLengthGreaterThan,
  matchesField,
  hasLengthLessThan,
} from "revalidate";

const validate = combineValidators({
  CurrentPassword: composeValidators(
    isRequired({ message: "La contraseña anterior es obligatoria" }),
    hasLengthGreaterThan(7)({
      message: "La contraseña debe tener al menos 8 caracteres",
    }),
    hasLengthLessThan(65)({
      message: "La contraseña debe tener máximo 64 caracteres",
    })
  )(),
  NewPassword: composeValidators(
    isRequired({ message: "La contraseña nueva es obligatoria" })
  )(),
  NewPasswordConfirm: composeValidators(
    isRequired({ message: "Éste campo es obligatorio" }),
    matchesField(
      "NewPassword",
      ""
    )({
      message: "Clave no coincide con contraseña nueva",
    })
  )(),
});

const ChangePasswordForm = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { changePassword } = rootStore.userStore;
  const { loading } = rootStore.buttonLoadingStore;

  //variables para mostrar la contraseña
  const [shown, setShown] = useState(false);
  const switchShown = () => setShown(!shown);

  //variables para el uso del checkbox
  const [validaciones] = useState({
    v1: false,
    v2: false,
    v3: false,
    v4: false,
  });

  //expreciones regulares a validar
  const regex1 = /.{8,}/;
  const regex2 = /[a-z]+/;
  const regex3 = /[A-Z]+/;
  const regex4 = /^(?=.*\d)|(\W)/;

  const [cambioCon] = useState<IUserChangePassword>({
    CurrentPassword: "",
    NewPassword: "",
    NewPasswordConfirm: "",
  });

  const handleFinalFormSubmit = (values: any) => {
    if (
      validaciones.v1 &&
      validaciones.v2 &&
      validaciones.v3 &&
      validaciones.v4
    ) {
      cambioCon.NewPassword = values.newpassword;
      cambioCon.CurrentPassword = values.password;
      changePassword(values);
    } else {
      toast.error("Requisitos incompletos para cambiar tu clave");
    }
  };

  const validacionCheck = (value: any) => {
    if (value.target.name === "NewPassword") {
      let str = value.target.value;

      //validacion min 8 caracteres
      if (regex1.test(str)) validaciones.v1 = true;
      else validaciones.v1 = false;

      //validacion 1 carácter min
      if (regex2.test(str)) validaciones.v2 = true;
      else validaciones.v2 = false;

      //validacion 1 carácter may
      if (regex3.test(str)) validaciones.v3 = true;
      else validaciones.v3 = false;

      //validacion
      if (regex4.test(str)) validaciones.v4 = true;
      else validaciones.v4 = false;
    }
  };

  return (
    <div className="modalContent">
      <FinalForm
        validate={validate}
        initialValues={cambioCon}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit} onChange={validacionCheck}>
            <label>Contraseña anterior</label>
            <Field
              name="CurrentPassword"
              type="password"
              value={cambioCon.CurrentPassword}
              component={TextInput}
            />
            <Grid>
              <Grid.Column floated="left" width={8}>
                <label>Contraseña nueva</label>
              </Grid.Column>
              <Grid.Column floated="right" width={6}>
                <a href="#" className="password__button" onClick={switchShown}>
                  {shown ? "Ocultar contraseña" : "Mostrar contraseña"}
                </a>
              </Grid.Column>
            </Grid>

            <Field
              name="NewPassword"
              value={cambioCon.NewPassword}
              type={shown ? "text" : "password"}
              component={TextInput}
            />
            <label>Confirma tu contraseña</label>
            <Field
              name="NewPasswordConfirm"
              id="NewPasswordConfirm"
              type="password"
              placeholder="Contraseña"
              value={cambioCon.NewPasswordConfirm}
              component={TextInput}
            />
            <label>Requisitos para la contraseña:</label>
            <div className="passwordRequirements">
              <br />
              <Form.Field>
                <Checkbox
                  label="Al menos 8 caracteres de longitud"
                  checked={validaciones.v1 ? true : false}
                  readOnly
                />
              </Form.Field>
              <Form.Field>
                <Checkbox
                  label="Un carácter en minúscula"
                  checked={validaciones.v2 ? true : false}
                  readOnly
                />
              </Form.Field>
              <Form.Field>
                <Checkbox
                  label="Un carácter en mayúscula"
                  checked={validaciones.v3 ? true : false}
                  readOnly
                />
              </Form.Field>
              <Form.Field>
                <Checkbox
                  label="Un número, símbolo o espacio en blanco"
                  checked={validaciones.v4 ? true : false}
                  readOnly
                />
              </Form.Field>
            </div>
            <br />
            <Button
              loading={loading}
              disabled={loading}
              className="ui primary button"
              color="blue"
              type="submit"
              content="Guardar"
            />
          </Form>
        )}
      />
    </div>
  );
};

export default ChangePasswordForm;
